module.exports = __webpack_public_path__ + "static/media/shopify.a64d29dd.svg";